import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useFedStore } from '../store';
import { useFedContent, uploadUrl } from '../content';
import { Ic } from '../icons';
import { PageHead, Rv } from '../ui';

const COPY = {
  ru: { eye: 'События федерации', title: 'Галерея', sub: 'Турниры, финалы и жизнь нашего сообщества в фотографиях.', empty: 'Фотографии скоро появятся', download: 'Скачать оригинал', close: 'Закрыть' },
  kz: { eye: 'Федерация оқиғалары', title: 'Галерея', sub: 'Турнирлер, финалдар және қауымдастық өмірі фотосуреттерде.', empty: 'Фотосуреттер жақында пайда болады', download: 'Түпнұсқаны жүктеу', close: 'Жабу' },
};

export default function FedGallery() {
  const lang = useFedStore((s) => s.lang);
  const photos = useFedContent((s) => s.gallery) || [];
  const [active, setActive] = useState(null);
  const C = COPY[lang] || COPY.ru;
  useEffect(() => {
    if (!active) return undefined;
    const close = (event) => { if (event.key === 'Escape') setActive(null); };
    const previousBodyOverflow = document.body.style.overflow;
    const previousHtmlOverflow = document.documentElement.style.overflow;
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    window.addEventListener('keydown', close);
    return () => {
      document.body.style.overflow = previousBodyOverflow;
      document.documentElement.style.overflow = previousHtmlOverflow;
      window.removeEventListener('keydown', close);
    };
  }, [active]);

  return (
    <div className="fed-gallery-page fed-pagewrap max-w-[1380px] mx-auto">
      <PageHead eyebrow={C.eye} title={C.title} sub={C.sub} mb={36} />
      {photos.length ? (
        <div className="fed-gallery-masonry">
          {photos.map((photo, index) => (
            <Rv as="button" className="fed-gallery-tile" delay={(index % 6) * 0.035} key={photo.id || photo.path} onClick={() => setActive(photo)} aria-label={photo[`title_${lang}`] || photo.title_ru || C.title}>
              <img src={uploadUrl(photo.path)} alt={photo[`title_${lang}`] || photo.title_ru || ''} loading="lazy" />
              <span><b>{photo[`title_${lang}`] || photo.title_ru || photo.originalName || C.title}</b>{photo.date && <time>{photo.date}</time>}</span>
            </Rv>
          ))}
        </div>
      ) : <div className="fed-gallery-empty"><Ic name="image" size={36} /><b>{C.empty}</b></div>}

      {active && createPortal((
        <div className="fed-gallery-lightbox" role="dialog" aria-modal="true" aria-label={active.title_ru || C.title} onMouseDown={(event) => { if (event.target === event.currentTarget) setActive(null); }}>
          <button className="fed-gallery-close" onClick={() => setActive(null)} aria-label={C.close}><Ic name="x" size={22} /></button>
          <div className="fed-gallery-lightbox-media" onMouseDown={(event) => { if (event.target === event.currentTarget) setActive(null); }}>
            <img src={uploadUrl(active.path)} alt={active[`title_${lang}`] || active.title_ru || ''} />
          </div>
          <div className="fed-gallery-lightbox-bar">
            <div><b>{active[`title_${lang}`] || active.title_ru || active.originalName}</b>{active.date && <time>{active.date}</time>}</div>
            <a download href={`${uploadUrl(active.path)}?download=1&name=${encodeURIComponent(active.originalName || 'photo')}`}><Ic name="download" size={19} />{C.download}</a>
          </div>
        </div>
      ), document.body)}
    </div>
  );
}
